import { SUB_JOB_ISSUE_REQUEST, CREATE_SUB_JOB_ISSUE, GET_SUB_JOB_ISSUES, UPDATE_SUB_JOB_ISSUE, DELETE_SUB_JOB_ISSUE,
    SUB_JOB_ISSUE_REQUEST_FAILURE } from '../types';

const initialState = {
  subJobIssues: [],
  loading: false,
  error: null,
};

const subJobIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUB_JOB_ISSUE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_SUB_JOB_ISSUES: {
      return {
        ...state,
        subJobIssues: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_SUB_JOB_ISSUE:
      return {
        ...state,
        subJobIssues: [action.payload, ...state.subJobIssues],
        loading: false,
        error: null
      };
    case UPDATE_SUB_JOB_ISSUE:
      const subJobIssuesData = state.subJobIssues.slice(0);
      const uIndex = subJobIssuesData.findIndex((data) => data.id === action.payload.id);
      subJobIssuesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        subJobIssues: [ ...subJobIssuesData ],
        loading: false,
        error: null
      };
    case DELETE_SUB_JOB_ISSUE:
      const subJobIssues = state.subJobIssues?.slice(0);
      const index = subJobIssues.findIndex((data) => data.id === action.id);
      if (index > -1) {
        subJobIssues.splice(index, 1);
      }
      return {
        ...state,
        subJobIssues: [...subJobIssues],
        loading: false,
        error: null
      }
    case SUB_JOB_ISSUE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default subJobIssueReducer;
